import styled from 'styled-components';
export const LabelForm = styled.label`
  font-weight: 700;
  margin-bottom: 5px;
  display: block;
`;